<script name="RanderCanvas" setup>
import Editor from '@/editor'
import ResizeCanvasPlugin from '@/editor/Plugins/ResizeCanvasPlugin'
import ListenerPlayTimePlugin from '@/editor/Plugins/ListenerPlayTimePlugin'
import { timelineStore } from '@/store/timelineStore'
const timelineStoreState = timelineStore()
const previewBox = ref(null)
/**
 * @type {Editor}
 */
let editor
function editorLoaded() {
	if (!editor) return
	editor.loaded(async () => {
		// 改背景是
		editor.updateBackgroundColor(33 / 255, 33 / 255, 33 / 255)
		setTimeout(() => {
			timelineStoreState.setEditorLoaded(true)
		}, 500)
	})
}
const canvasRef = ref(null)
onMounted(() => {
	console.log('绑定sdk的id + vvv_my_canvas')
	console.log('绑定sdk的dom !!!!!!!!!!!!!!!!', canvasRef.value)
	editor = new Editor('vvv_my_canvas')
	editorLoaded() // 加载wasm之后执行
	const resizeCanvas = new ResizeCanvasPlugin(previewBox.value) // 编辑区自适应plugin 参数为要监听变化的dom
	// 插件可以是构造函数 也可以是实例 在哪里插入插件都可以 都会在wasm之后加载插件
	editor.use(resizeCanvas) // 注册编辑区自适应plugin
	// editor.use(ControlsPlugin) // 编辑框样式
	// editor.use(AlignGuidLinePlugin); // 辅助线
	editor.use(ListenerPlayTimePlugin) // 渲染帧与时间轴对齐插件
	// editor.use(ExtractTimeFramesPlugin); // 抽帧
	// editor.use(RightClickMenuPlugin); // 右键菜单
	// editor.use(HotkeysPlugin); // 快捷键插件
	// editor.use(ClickOutsideEditorPlugin); // 点击编辑器之外的操作 比如说取消选中框等等
	editor.init() // 开始加载
})
</script>
<template>
	<div class="preview-box" ref="previewBox">
		<div class="editor-wrap">
			<canvas id="vvv_my_canvas" class="prew-canvas" ref="canvasRef" />
			<canvas width="1920" height="1080" id="editorCanvas" />
		</div>
	</div>
</template>
<style lang="less" scoped>
.preview-box {
	width: 100%;
	height: 100%;
	position: relative;

	.editor-wrap {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
	}
}
canvas {
	will-change: transform;
	transform: translateZ(0);
}
:deep(.canvas-container) {
	display: none;
}
</style>
